import { Box  } from '@chakra-ui/react';
import type { BoxProps } from '@chakra-ui/react';
import type { PropsWithChildren } from 'react';

export const ContentWrapper = ({ children, ...props }: PropsWithChildren<BoxProps>) => {
	return (
		<Box
			px={{ base: 8, md: 16 }}
			py={{ base: 8, md: 10 }}
			w="100%"
			{...props}
		>
			{children}
		</Box>
	);
};
